import GeoJSON, { Feature } from 'geojson';

export type TCoords = [number, number];

export function coordsToFeature(coords: TCoords): Feature {
	// @ts-expect-error: No typings for GeoJSON.parse
	return GeoJSON.parse({ name: 'location', coords }, { Point: 'coords' });
}
